import { render, staticRenderFns } from "./PurchaseRecord.vue?vue&type=template&id=17f4a96e&scoped=true"
import script from "./PurchaseRecord.vue?vue&type=script&lang=js"
export * from "./PurchaseRecord.vue?vue&type=script&lang=js"
import style0 from "./PurchaseRecord.vue?vue&type=style&index=0&id=17f4a96e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f4a96e",
  null
  
)

export default component.exports